// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".body{\n    -webkit-rtl-ordering: revert;\n}\n#outlined-basic{\n    width: 90% !important;\n}", "",{"version":3,"sources":["webpack://./src/pages/donor-add/DonorAdd.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".body{\n    -webkit-rtl-ordering: revert;\n}\n#outlined-basic{\n    width: 90% !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
